import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import "./Navber.css";
import logo from "../Images/dhanushdhari_final_log.jpeg";
import { ProfileUser } from "../../Services/Operations/ProductAPI";
import Cookies from 'js-cookie';
import { useSelector } from "react-redux";


const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const[profileData,setProfileData]=useState(null)

  const navigate = useNavigate();
  const location = useLocation();

  const isHome = location.pathname === "/";

  const { isAuthenticated, user } = useSelector((state) => state.auth);

  const handleGetProfile=async()=>{
    try {
     // let token="37|0VkKZNYBoQ0rVzDp58P1N5tyxBAXzx2Dkmdw881R"
      const token = Cookies.get('rental-token');
      const res=await ProfileUser(token)
      console.log(res);
      if(res.status===200){
          setProfileData(res.data.data)
      }
      
    } catch (error) {
      console.log(error);
      
    }
  }

  useEffect(() => {
    handleGetProfile()
    const handleScroll = () => {
      if (isHome) {
        setScrolled(window.scrollY > 50);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isHome]);

  const menuItems = [
    { name: "Properties", href: "#properties" },
    { name: "About Us", href: "#about" },
    { name: "Contact Us", href: "#contact" },
  ];

  return (
    <nav
      className={`legal-navbar ${
        isHome ? (scrolled ? "scrolled" : "home-transparent") : "scrolled"
      }`}
    >
      <div className="nav-container">

        {/* Logo */}
<div className="nav-logo" onClick={() => navigate("/")}>
  <img src={logo} alt="Dhanushdhari Rental Logo" className="nav-logo-img"/>
  <span className="nav-logo-text">
    DHANUSHDHARI<span className="gold-text"> RENTAL</span>
  </span>
</div>

        {/* Desktop Menu */}
        <ul className="nav-links">
          {menuItems.map((item) => (
            <li key={item.name}>
              <a href={item.href}>{item.name}</a>
            </li>
          ))}
          <button className="book-btn" onClick={()=>navigate("/search-results")}>Book Now</button>
        </ul>
     <div onClick={()=>{isAuthenticated?navigate("/profile"):navigate("/login")}}>
        <img src="/user.png"
        style={{backgroundColor:"#fefefe",borderRadius:"50%"}}/>
        </div>
        {/* Hamburger */}
        <div
          className={`hamburger ${isOpen ? "active" : ""}`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* Mobile Menu */}
        <AnimatePresence>
          {isOpen && (
            <motion.div
              className="mobile-overlay"
              initial={{ x: "100%" }}
              animate={{ x: 0 }}
              exit={{ x: "100%" }}
              transition={{ type: "spring", damping: 25, stiffness: 200 }}
            >
              <ul className="mobile-nav-links">
                {menuItems.map((item) => (
                  <li key={item.name}>
                    <a href={item.href} onClick={() => setIsOpen(false)}>
                      {item.name}
                    </a>
                  </li>
                ))}
                <button className="book-btn mobile">Book Now</button>
              </ul>
            </motion.div>
          )}
        </AnimatePresence>

       

      </div>
    
    </nav>
  );
};

export default Navbar;